// extracted by mini-css-extract-plugin
module.exports = {"center":"ClassScheduleTime_center__1tWUk","padding":"ClassScheduleTime_padding__2wObV","ClassScheduleTime":"ClassScheduleTime_ClassScheduleTime__1tRvx"};